import { AppFooterLinks } from '@/layouts/components/AppFooterLinks'
import { AppLogo } from '@/layouts/components/AppLogo'

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className='bg-muted/60 flex min-h-screen w-full flex-col items-center justify-center space-y-8 px-4 py-12 md:space-y-10'>
      <AppLogo />
      {children}
      <AppFooterLinks />
    </div>
  )
}
